import { Injectable } from '@angular/core';
import { Observable, timer } from 'rxjs';
import { share } from 'rxjs/operators';

/**
 * Serves as a single source of truth
 * for the second-hand tick of a clock.
 * Synchronizes all the countdown timers in the app ✨
 */
@Injectable({
  providedIn: 'root',
})
export class TimerService {
  public seconds$: Observable<number> = timer(0, 1000).pipe(share());
  public minutes$: Observable<number> = timer(0, 60000).pipe(share());
}
